import { render, staticRenderFns } from "./BasicJumbotron.vue?vue&type=template&id=254e0498"
import script from "./BasicJumbotron.vue?vue&type=script&lang=js"
export * from "./BasicJumbotron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports